import KendoScheduler from './KendoScheduler'
import KendoSchedulerResource from './KendoSchedulerResource'
import KendoSchedulerView from './KendoSchedulerView'
import KendoSchedulerInstaller from './kendo-scheduler-installer'

export { KendoScheduler, KendoScheduler as Scheduler, KendoSchedulerResource, KendoSchedulerResource as SchedulerResource, KendoSchedulerView, KendoSchedulerView as SchedulerView, KendoSchedulerInstaller, KendoSchedulerInstaller as SchedulerInstaller }


// WEBPACK FOOTER //
// ./packages/kendo-scheduler-vue-wrapper/src/index.js